/* eslint-disable */

import { durations, frequencies } from "@/config/subscriptions";
import Vue from "vue";
import Component from "vue-class-component";

export interface Duration {
  id: number;
  label: string;
}

export interface Frequency {
  id: number;
  label: string;
}

const mapRecord = (record: Record<number, string>): { id: number; label: string }[] => {
  return Object.keys(record).map((id) => ({
    id: Number(id),
    label: record[Number(id)],
  }));
};

@Component
class WithBuilderSubscriptionConfig extends Vue {
  // eslint-disable-next-line class-methods-use-this
  get durations(): Duration[] {
    return mapRecord(durations);
  }

  // eslint-disable-next-line class-methods-use-this
  get frequencies(): Frequency[] {
    return mapRecord(frequencies);
  }
}

export default WithBuilderSubscriptionConfig;
